import { Stack } from "@mantine/core";
import {
  TextInput,
  Checkbox,
  Select,
  MultiSelect,
} from "react-hook-form-mantine";
import { DatePickerInput } from "@mantine/dates";
import { Controller } from "react-hook-form";
import CountrySelect from "../../CountrySelect";
import { useTranslation } from "react-i18next";

export default function CustomFieldsRenderer({
  control,
  customFields,
  parentPath = "",
}) {
  const { t } = useTranslation();
  if (!customFields || customFields.length === 0) return null;

  const renderField = (field) => {
    const name = parentPath
      ? `${parentPath}.${field.key}`
      : `additionalFields.${field.key}`;

    const label = field.label || field.labelI18n?.en || field.key || "";

    if (field.type === "country") {
      return (
        <CountrySelect
          key={name}
          control={control}
          name={name}
          label={label}
          placeholder={t("select_country")}
          withAsterisk={field.required}
        />
      );
    }

    if (field.type === "text") {
      return (
        <TextInput
          key={name}
          control={control}
          name={name}
          label={label}
          placeholder={`${t("enter")} ${label.toLowerCase()}`}
          withAsterisk={field.required}
        />
      );
    }

    if (field.type === "date") {
      return (
        <Controller
          key={name}
          name={name}
          control={control}
          render={({ field: f, fieldState }) => (
            <DatePickerInput
              label={label}
              placeholder={t("pick_date")}
              withAsterisk={field.required}
              error={fieldState?.error?.message}
              value={f.value ?? null}
              onChange={(date) => f.onChange(date ?? null)}
              valueFormat="YYYY-MM-DD"
              clearable={!field.required}
            />
          )}
        />
      );
    }

    if (field.type === "boolean") {
      return (
        <Checkbox
          key={name}
          control={control}
          name={name}
          label={label}
          description={field.placeholder}
          defaultValue={false}
        />
      );
    }

    if (field.type === "select") {
      return (
        <Select
          key={name}
          control={control}
          name={name}
          label={label}
          placeholder={t("select_option")}
          withAsterisk={field.required}
          data={field.options || []}
          clearable={!field.required}
        />
      );
    }

    if (field.type === "multiselect") {
      return (
        <MultiSelect
          key={name}
          control={control}
          name={name}
          label={label}
          placeholder={t("select_options")}
          withAsterisk={field.required}
          data={field.options || []}
          clearable={!field.required}
        />
      );
    }

    return null;
  };

  return (
    <Stack gap="sm">
      {customFields
        .sort((a, b) => (a.order || 0) - (b.order || 0))
        .map(renderField)}
    </Stack>
  );
}
